// src/pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
	return (
		<div className="notFound">
			<p className="errorPageText">404</p>
			<p className="apology">We are sorry this page doesn't exist</p>
			<Link to="/">
				<button aria-label="Back to Home" className="cta ">
					<i className="fa-solid fa-circle-chevron-left"></i>Back to Home
				</button>
			</Link>
		</div>
	);
};

export default NotFound;
